import { writable } from 'svelte/store';
import constants from './constants.js';
import initials from './helpers/initials.js';
import getHighestLegacyRole from './helpers/getHighestLegacyRole.js';

export const auth0 = writable(null);
export const signedInUser = writable();
export let appState = writable({});

export let samlConnectionName = writable(null);

export async function setUser(_isNewTokenStructure, _accessTokenDecoded, _user) {

  let _signedInUser = {
    id: _user[constants.CLAIMS.NAME_IDENTIFIER],
    name: _user[constants.CLAIMS.FULL_NAME] || _user[constants.LEGACY_CLAIMS.NAME],
    firstName: _user[constants.CLAIMS.FIRST_NAME] || _user[constants.LEGACY_CLAIMS.GIVEN_NAME],
    lastName: _user[constants.CLAIMS.LAST_NAME] || _user[constants.LEGACY_CLAIMS.FAMILY_NAME],
    email: _user[constants.CLAIMS.EMAIL] || _user[constants.LEGACY_CLAIMS.EMAIL],
    hasPasswordExpired: _user[constants.CLAIMS.HAS_PASSWORD_EXPIRED] || _user[constants.LEGACY_CLAIMS.HAS_PASSWORD_EXPIRED],
    needsFederatedLogout: _user[constants.CLAIMS.NEEDS_FEDERATED_LOGOUT] || _user[constants.LEGACY_CLAIMS.NEEDS_FEDERATED_LOGOUT],
    debtor: _user[constants.LEGACY_CLAIMS.DEBTOR] || _user[constants.LEGACY_CLAIMS.DEBTOR_ALT],
    debtorName: _user[constants.LEGACY_CLAIMS.DEBTOR_NAME],
    roles: _user[constants.LEGACY_CLAIMS.ROLES],
    roleTypeName: getHighestLegacyRole(_user[constants.LEGACY_CLAIMS.ROLES]),
    externalReference: _user[constants.LEGACY_CLAIMS.TRAVELLER_ID],
  }

  _signedInUser.initials = initials(_signedInUser.name);

  if (_isNewTokenStructure) {
    _signedInUser = {
      ..._signedInUser,
      roles: _accessTokenDecoded[constants.CLAIMS.ROLE_TYPES],
      roleTypeName: _accessTokenDecoded[constants.CLAIMS.ROLE_TYPE_NAME],
      defaultDebtor: _accessTokenDecoded[constants.CLAIMS.DEFAULT_DEBTOR],
      debtor: _accessTokenDecoded[constants.CLAIMS.DEBTOR],
      debtorName: _accessTokenDecoded[constants.CLAIMS.DEBTOR_NAME],
      externalReference: _accessTokenDecoded[constants.CLAIMS.EXTERNAL_REFERENCE],
      applicationEntities: _accessTokenDecoded[constants.CLAIMS.APPLICATION_ENTITIES]
    }
  }

  signedInUser.set(_signedInUser);
}
